import $ from 'jquery';
import { setupSelectCountryStateCity } from './../components/forms/form-helper';

function setupForm() {
    var $form = $('.dealer-form');
    var $btnSubmit = $('.dealer-form button');
    var $selectCountry = $('.dealer-form select[name="country_id"]');
    var $contentDealers = $('.content-dealers');

    $('.dealer-form select').on('change', function () {
        if ($btnSubmit.hasClass('loading')) {
            return;
        }

        if (!$selectCountry.val()) {
            $contentDealers.empty();
            return;
        }

        $btnSubmit.addClass('loading');

        //Roda no próximo tick, p/ dar tempo de zerar os valores dos combos relacionados (country -> state -> city) p/ solicitar o registro correto para a API
        setTimeout(function () {
            $.ajax({
                type: 'GET',
                url: $form.data('action'),
                data: $form.serialize(),
                success: function (data) {
                    $contentDealers.html(data.html);
                    $btnSubmit.removeClass('loading');
                },
                error: function (data) {
                    console.error(data);
                    $btnSubmit.removeClass('loading');
                },
            });
        });
    });
}

function initialize() {
    setupForm();

    setupSelectCountryStateCity($('.page-dealer'), true);
}

initialize();
